'use client';

import React, { memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styles from './DestinationCarousel.module.scss';
import { useAOS } from '../../../../lib/hooks/useAOS';

type Destination = {
    name: string;
    description: string;
    imageUrl: string;
    link: string;
};

type Props = {
    title?: string;
    subtitle?: string;
    destinations: Destination[];
};

const DestinationCarousel = ({
    title = 'Our Favorite Escapes',
    subtitle = 'DESTINATIONS',
    destinations,
}: Props) => {
    useAOS();

    return (
        <section className={styles.section} aria-labelledby="dest-carousel-title">
            <div className={styles.header}>
                <span className={styles.subtitle} data-aos="fade-right">
                    {subtitle}
                </span>
                <h2 className={styles.title} data-aos="zoom-in" id="dest-carousel-title">
                    {title}
                </h2>
            </div>

            <div className={styles.grid}>
                {destinations.map((destination, index) => (
                    <div
                        data-aos="fade-up"
                        data-aos-delay={index * 100}
                        key={`${destination.name}-${index}`}
                    >
                        <Link
                            href={destination.link}
                            aria-label={`Explore ${destination.name}`}
                            className={styles.card}
                        >
                            <Image
                                src={destination.imageUrl}
                                alt={destination.name}
                                width={400}
                                height={300}
                                className={styles.image}
                                loading="lazy"
                            />
                            <div className={styles.overlay}>
                                <h3>{destination.name}</h3>
                                <p>{destination.description}</p>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default memo(DestinationCarousel);
